export const FOCUS_AREAS_SLIDE_CODE = 11;
export const FOCUS_PRIORITY_SLIDE_CODE = 58;
export const FOCUS_PRIORITY_FIELD = 'priorityFocus';

const getSlideEntry = (slideValues, slideCode) => slideValues?.[slideCode] || slideValues?.[String(slideCode)] || {};

const flattenSlideControls = (slide = []) =>
  slide.flatMap((component) => {
    if (!component) return [];
    if (component.type === 'group' && Array.isArray(component.controls)) return component.controls;
    return [component];
  });

export const getFocusAreaOptionsFromSlide = (slide = []) =>
  flattenSlideControls(slide)
    .filter((component) => component?.type === 'img-checkbox' && component.name)
    .map((component) => ({
      name: component.name,
      label: component.label,
      answerCode: component.answerCode,
      img: component.img,
    }));

export const getFocusAreaOptionsFromQuizData = (quizData = []) => {
  const focusAreaSlide = quizData.find((slide) => slide?.[0]?.code === FOCUS_AREAS_SLIDE_CODE);
  return getFocusAreaOptionsFromSlide(focusAreaSlide);
};

export const getSelectedFocusAreas = (slideValues = {}, focusAreaOptions = []) => {
  const focusAreaValues = getSlideEntry(slideValues, FOCUS_AREAS_SLIDE_CODE);
  return focusAreaOptions.filter((option) => !!focusAreaValues?.[option.name]?.value);
};

export const getFocusPriorityValue = (slideValues = {}) => {
  const priorityEntry = getSlideEntry(slideValues, FOCUS_PRIORITY_SLIDE_CODE);
  const priorityValue = priorityEntry?.[FOCUS_PRIORITY_FIELD]?.value;
  return Array.isArray(priorityValue) ? priorityValue : [];
};

export const getFocusPriorityRequiredCount = (selectedFocusAreas = []) =>
  selectedFocusAreas.length > 0 ? 1 : 0;

export const getFocusPriorityMaxCount = (selectedFocusAreas = []) =>
  Math.min(selectedFocusAreas.length, 3);

export const normalizeFocusPriority = (priorityValue = [], selectedFocusAreas = []) => {
  const selectedByName = new Map(selectedFocusAreas.map((option) => [option.name, option]));

  return [...priorityValue]
    .sort((a, b) => Number(a?.rank || 0) - Number(b?.rank || 0))
    .filter((item) => item?.name && selectedByName.has(item.name))
    .slice(0, getFocusPriorityMaxCount(selectedFocusAreas))
    .map((item, index) => {
      const selected = selectedByName.get(item.name);
      return {
        rank: index + 1,
        name: selected.name,
        label: selected.label,
        answerCode: selected.answerCode,
      };
    });
};

export const buildAutoFocusPriority = (selectedFocusAreas = []) => {
  if (selectedFocusAreas.length !== 1) return [];
  const [selected] = selectedFocusAreas;
  return [
    {
      rank: 1,
      name: selected.name,
      label: selected.label,
      answerCode: selected.answerCode,
    },
  ];
};
